const env = process.env.REACT_APP_ENV ;
console.log("env",env)

let redirectUri = 'http://localhost:3000';
let oAuth2Url = 'https://test-login.dakika.com.tr';
let galleryRedirect ='https://test-gallery.dakika.com.tr';

  if (env === 'dev') {
  redirectUri = 'https://dev-glasshouse-masraf.dakika.com.tr';
  oAuth2Url = 'http://dev.sso-service.dtst.k8s';
  galleryRedirect = 'https://dev-gallery.dakika.com.tr/';
  } else if (env === 'test') {
  redirectUri = 'https://testmasraf.dakika.com.tr';
  oAuth2Url = 'https://test-login.dakika.com.tr';
  galleryRedirect = 'https://test-gallery.dakika.com.tr';
  } else if (env === 'production') {
  redirectUri = 'https://masraf.dakika.com.tr';
  oAuth2Url = 'https://login.dakika.com.tr';
  galleryRedirect = 'https://gallery.dakika.com.tr';
}

export default{
  url: oAuth2Url,
  authorizationPath: '/oauth/authorize',
  checkUserPath: '/oauth/user',
  clientId: 'dakika3g-fe',
  redirectUri,
  responseType: 'code',
  scope: 'uid',
  galleryRedirect
};
